import { render } from "./SuccessBadge.vue?vue&type=template&id=0247133a"
import script from "./SuccessBadge.vue?vue&type=script&lang=js"
export * from "./SuccessBadge.vue?vue&type=script&lang=js"

import exportComponent from "/home/noe/Dev/atc/agrotecchain_vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__